import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { sitecoreAxios } from './core.axios.js';
import { buildUrl } from './util.build-url.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS
});
function getGlossaryWord(portalId, glossaryWordId, options) {
  const url = buildUrl(
    `/api/v1/portals/${portalId}/glossaryterms/${glossaryWordId}`,
    options
  );
  return cache(!(options == null ? void 0 : options.disableCache) ? url : void 0, async () => {
    try {
      const response = await sitecoreAxios.get(url);
      const input = response.data.definition ?? response.data.e;
      if (!input) {
        return "";
      }
      return input;
    } catch (err) {
      console.warn("getGlossaryWord(): Failed to fetch glossary word", err);
      return "";
    }
  }).getStaleWhileRevalidate();
}

export { getGlossaryWord };
//# sourceMappingURL=request.get-glossary-word.js.map
